import { FC } from 'react';

import { useSelector } from 'react-redux';

import { ShowIfRole } from '@app/routes/roles/withRoleAccess';
import { AuthControl } from '@features/auth-control';
import DateTime from '@features/date-time';
import { GeoSelect } from '@features/geo-select';
import { selectDownloading } from '@features/loading';
import PageTitle from '@features/page-title';
import ToggleSidebar from '@features/toggle-sidebar';
import { Download } from '@mui/icons-material';
import { IconButton, Box, Tooltip } from '@mui/material';
import './header.css';

interface IProps {
  isMobSidebarOpen: boolean;
  setMobIsSidebarOpen: (value: boolean) => void;
}

const Header: FC<IProps> = ({ isMobSidebarOpen, setMobIsSidebarOpen }) => {
  const isDownloading = useSelector(selectDownloading);

  return (
    <header>
      <ToggleSidebar
        setMobIsSidebarOpen={setMobIsSidebarOpen}
        isMobSidebarOpen={isMobSidebarOpen}
      />

      <PageTitle />

      <DateTime />

      <div className='header-right-block'>
        {isDownloading && (
          <Box className='download-container'>
            <Tooltip title='Your download is being prepared. Please wait...'>
              <IconButton className='download-icon-btn'>
                <Download />
              </IconButton>
            </Tooltip>
          </Box>
        )}
        <ShowIfRole roles={['admin', 'operator']}>
          <GeoSelect />
        </ShowIfRole>
        <AuthControl />
      </div>
    </header>
  );
};

export default Header;
